export const getTagUrl = (sectionUrl: string, slug?: string) => `${sectionUrl}/tags/${slug}`;
